import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const brokeredLoadFileDeleteAtom = createMutationAtomFactory(
  'brokerage.brokeredLoadFileDelete',
  (params: { fileId: string }) => ({
    tradeFileDelete: {
      __args: { fileId: params.fileId },
    },
  }),
  { showLoadingOverlay: false },
);
